import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../Components/Common/RequestsTableContainr";

import { TransactionID, Status } from "./TransactionsCol";
import { getFees } from "../../store/actions";
import ListLoader from "../../Components/modules/ListLoader";
import EmptyList from "../../Components/EmptyList";

import { APIClient } from "../../utils/api_helper";

import useSWR from "swr";

import { useSearchParams } from "react-router-dom";
import LoanModal from "./Modals/LoanModal";
import RefreshButton from "../../Components/Loaders/RefreshButton";

const api = new APIClient();

const crowdfundListFetcher = async (url) => {
  const data = await api.get(url);

  return data;
};

const AllCrowdFundList = () => {
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  let {
    data: crowdfund,
    error: transactionList_error,
    isValidating,
    mutate,
  } = useSWR(`/crowdfund/`, crowdfundListFetcher);

  console.log(crowdfund, "crowdfundcrowdfundcrowdfund");

  const [openLoanModal, setOpenLoanModal] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "Target amount",
        filterable: true,
        Cell: (cellProps) => {
          const amount = cellProps.row.original?.target_amount;
          return (
            <React.Fragment>
              <span className="">
                {user?.currency_symbol} {amount}
              </span>
            </React.Fragment>
          );
        },
      },
      {
        Header: "Progress amount",
        filterable: true,
        Cell: (cellProps) => {
          const current_amount = cellProps.row.original?.current_amount;
          return (
            <React.Fragment>
              <span className="">
                {user?.currency_symbol} {current_amount}
              </span>
            </React.Fragment>
          );
        },
      },

      {
        Header: "title",
        accessor: "title",
        filterable: false,
      },

      // {
      //   Header: "created at",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     const created_at_time = cellProps.row.original?.created_at_time;
      //     return (
      //       <React.Fragment>
      //         <span className="">{created_at_time}</span>
      //       </React.Fragment>
      //     );
      //   },
      // },

      {
        Header: "Status",
        accessor: "status",
        filterable: false,
        Cell: (cellProps) => {
          return <Status status={cellProps.row.original.status} />;
        },
      },

      {
        Header: "Action",
        Cell: (cell) => {
          const id = cell.row.original.slug;
          return (
            <UncontrolledDropdown>
              <DropdownToggle href="#" className="btn-soft-secondary btn-sm dropdown" tag="button">
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <Link to={`/crowdfund/${id}`} className="d-inline-block auth-logo">
                  <DropdownItem>
                    <i className="ri-eye-fill align-bottom me-2 text-muted"></i> View
                  </DropdownItem>
                </Link>

                <DropdownItem divider />
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    [user]
  );
  return (
    <React.Fragment>
      <Row className="align-items-center mb-4 g-3">
        <div className="col-sm-auto ms-auto col-auto">
          <div className="d-flex gap-2">
            <Link
              // onClick={() => setOpenLoanModal(!openLoanModal)}
              to="/createcrowdfund"
              data-bs-toggle="modal"
              className="btn btn-primary"
            >
              Create new crowdfund
            </Link>
          </div>
        </div>
      </Row>

      <Card>
        <CardHeader>
          <Row className="align-items-center g-3">
            <div className="col-md-auto ms-auto">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <h5 className="card-title mb-0">CrowdFund list</h5>
                <div className="d-flex justify-content-end">
                  <RefreshButton isValidating={isValidating} mutate={mutate} />
                </div>
              </div>
            </div>
          </Row>
        </CardHeader>
        <CardBody>
          <TableContainer
            columns={columns}
            data={crowdfund?.data || []}
            isGlobalFilter={false}
            isAddUserList={false}
            customPageSize={8}
            className="custom-header-css"
            divClass="table-responsive table-card mb-4"
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light table-nowrap"
            thClass="table-light text-muted"
            customFetchData={() => console.log("yesss")}
          />
        </CardBody>
        {isValidating ? <ListLoader /> : null}

        {!isValidating && !crowdfund?.data ? <EmptyList text="No transactions found yet!" /> : null}
      </Card>

      <LoanModal openModal={openLoanModal} setOpenModal={setOpenLoanModal} />
    </React.Fragment>
  );
};

export default AllCrowdFundList;
